import React from 'react';
import { classNames } from '../../utils/format';

export default function Badge({ tone, className, children }) {
  return <span className={classNames('badge', tone && `badge-${tone}`, className)}>{children}</span>;
}
